<div class="modal-header">
    <h3>{{'COMPARE_SEND.WHATS_DIFFERENCE_HOME_HELP.TITLE' | translate}}</h3>
</div>
<div class="modal-body">
    <p [innerHTML]="'COMPARE_SEND.WHATS_DIFFERENCE_HOME_HELP.TEXT' | translate"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary btn-sm" (click)="closeModal('close')" aria-label="Close">{{'GLOBAL.OK' | translate}}</button>
</div>
